import React, { useEffect, useRef } from "react";
import classNames from "classnames";


interface IndeterminateCheckboxProps {
    className?: string;
    status?: "all" | "none" | "partial";
    onChange: (checked: boolean) => void;
}

const IndeterminateCheckbox: React.FC<IndeterminateCheckboxProps> = (props) => {
    const { className: propsClassName, status, onChange } = props;

    const checkboxRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!checkboxRef?.current) {
            return;
        }
        checkboxRef.current.checked = status === "all";
        checkboxRef.current.indeterminate = status === "partial";
    }, [status]);

    return (
        <input type="checkbox"
               ref={checkboxRef}
               className={classNames("selection-table-checkbox", propsClassName)}
               onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                   onChange(e.target.checked);
               }}
        />
    );
};

export default IndeterminateCheckbox;
